import request from '@/utils/request'

// 创建机器人
export function createRobot(data) {
  return request({
    url: '/robots',
    method: 'post',
    data
  })
}

// 获取用户的所有机器人
export function getUserRobots() {
  return request({
    url: '/robots',
    method: 'get'
  })
}

// 获取单个机器人
export function getRobot(id) {
  return request({
    url: `/robots/${id}`,
    method: 'get'
  })
}

// 更新机器人
export function updateRobot(id, data) {
  return request({
    url: `/robots/${id}`,
    method: 'put',
    data
  })
}

// 删除机器人
export function deleteRobot(id) {
  return request({
    url: `/robots/${id}`,
    method: 'delete'
  })
}

// 控制机器人
export function controlRobot(id, action) {
  return request({
    url: `/robots/${id}/control`,
    method: 'put',
    data: { action }
  })
}

// 批量删除机器人
export function batchDeleteRobots(robotIds) {
  return request({
    url: '/robots/batch',
    method: 'delete',
    data: { robotIds }
  })
}

// 更新机器人角度设置
export function updateRobotAngles(id, data) {
  return request({
    url: `/robots/${id}/angles`,
    method: 'put',
    data
  })
}

// 获取默认角度设置
export function getDefaultAngleSettings() {
  return request({
    url: '/robots/default-angles',
    method: 'get'
  })
}

// 更新机器人排序
export function updateRobotOrder(layoutArray) {
  return request({
    url: '/robots/order',
    method: 'post',
    data: {
      layout: layoutArray
    }
  })
}

// ============== 管理员接口 ==============

// 获取机器人列表（管理员）
export function getAdminRobotList(params) {
  return request({
    url: '/admin/robots',
    method: 'get',
    params
  })
}

// 获取机器人详情（管理员）
export function getAdminRobotDetail(id) {
  return request({
    url: `/admin/robots/${id}`,
    method: 'get'
  })
}

// 更新机器人（管理员）
export function updateAdminRobot(id, data) {
  return request({
    url: `/admin/robots/${id}`,
    method: 'put',
    data
  })
}

// 删除机器人（管理员）
export function deleteAdminRobot(id) {
  return request({
    url: `/admin/robots/${id}`,
    method: 'delete'
  })
}

// 批量删除机器人（管理员）
export function batchDeleteAdminRobots(ids) {
  return request({
    url: '/admin/robots/batch',
    method: 'delete',
    data: { ids }
  })
}

// 更新机器人角度设置（管理员）
export function updateAdminRobotAngles(id, data) {
  return request({
    url: `/admin/robots/${id}/angles`,
    method: 'put',
    data
  })
}

// 获取机器人定时任务列表（管理员）
export function getAdminRobotSchedules(id) {
  return request({
    url: `/admin/robots/${id}/schedules`,
    method: 'get'
  })
}

// 获取机器人分享信息（管理员）
export function getAdminRobotShares(id) {
  return request({
    url: `/admin/robots/${id}/shares`,
    method: 'get'
  })
}

// 获取机器人日志（管理员）
export function getAdminRobotLogs(id, params) {
  return request({
    url: `/admin/robots/${id}/logs`,
    method: 'get',
    params
  })
}

// 恢复机器人出厂设置（管理员）
export function restoreRobot(id) {
  return request({
    url: `/admin/robots/${id}/restore`,
    method: 'delete'
  })
}

// 恢复巴法机器人出厂设置（管理员）
export function restoreBemfaRobot() {
  return request({
    url: `/admin/robots/restore-bemfa`,
    method: 'delete'
  })
}